import {
  createSourcedInviteRequestSchema,
  inviteDetailResponseSchema,
  talentFeedQuerySchema,
  talentFeedResponseSchema,
  talentProfileResponseSchema,
  type CreateSourcedInviteRequest,
  type TalentFeedQuery,
} from "@chotca/config";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

// Talent sourcing — "Tìm ứng viên" (docs/01-product.md). Employer browses open-to-work
// workers and sources them into a posting.
export function createTalentResource(ctx: RequestContext) {
  return {
    /** Cursor-paginated deck of open-to-work workers this org may invite. */
    feed(orgId: string, query: TalentFeedQuery = {}) {
      const q = talentFeedQuerySchema.parse(query);
      return requestJson(ctx, {
        method: "GET",
        path: `/orgs/${orgId}/talent`,
        query: q,
        dataSchema: talentFeedResponseSchema,
        auth: true,
      });
    },
    /** Full CV detail for one candidate (same shape as the applicant CV). */
    profile(orgId: string, workerId: string) {
      return requestJson(ctx, {
        method: "GET",
        path: `/orgs/${orgId}/talent/${workerId}`,
        dataSchema: talentProfileResponseSchema,
        auth: true,
      });
    },
    /** Source a worker into an OPEN posting (spends 1 lượt, sends an invite). */
    invite(orgId: string, workerId: string, body: CreateSourcedInviteRequest) {
      const payload = createSourcedInviteRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: `/orgs/${orgId}/talent/${workerId}/invite`,
        body: payload,
        dataSchema: inviteDetailResponseSchema,
        auth: true,
      });
    },
  };
}

export type TalentResource = ReturnType<typeof createTalentResource>;
